import React, {useState, useEffect} from "react";
import {getIcal} from 'network/ApiAxios'
import Header from 'components/Headers/Header';
import BookingCards from './BookingCards'
import { Container, Row, CustomInput, Button, Col, Modal, ModalBody, ModalFooter, Input } from "reactstrap";

const Rentals =(props)=>{
    //const user = JSON.parse(localStorage.getItem("user"));
    const[events, setEvents] = useState([])
    const [modalOpen, setModalOpen] = useState(false);
    useEffect(() => {
      ical()
    }, []);
   
    const ical = async () =>{
      const res = await getIcal()
      console.log(res)
      setEvents(res.data)
    }

    const saveProperty = async () =>{
      setModalOpen(false)
    }
    return (
      <>
        <Header/>
        <Container fluid>
          <Row className="mt-4">
            <Col xl="2" >
              <Button onClick={() => setModalOpen(true)} > Add New Property </Button>
            </Col>
              
          </Row>
          <Row className="mt-4">
            {events ? 
            events.map((event) =>{
              return (
                <BookingCards 
                key={event._id} 
                title={event.summary} 
                link={event.description} 
                uid={event._id} 
                dtstart={event.dtstart.split("T")[0]} 
                dtend={event.dtend.split("T")[0]}
                property={event.property} />
              )}) 
            : null}
          </Row>

          {/* change file name modal */}
          <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}>
            <div className=" modal-header">
              <h5 className=" modal-title" id="exampleModalLabel">
                Choose a name for the file
              </h5>
            </div>
            <ModalBody>
                                         
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                type="button"
                onClick={() => setModalOpen(!modalOpen)}
              >
                Cancel
              </Button>
              <Button color="primary" type="button" onClick={saveProperty}>
                Save changes
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </>
    );
  
}

export default Rentals;